import React, { useState } from "react";
import NavLink from "./NavLink";
import { navLinks } from "./NavLinks";
import "./Nav.css";
import avatar from "../img/willemdatema.webp";
import { FaBars, FaTimes } from "react-icons/fa";

const Nav = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  return (
    <div className="nav-bar">
      <a href="#homeContainer" className="logo">
        <img src={avatar} alt="Willem Datema" />
        <span className="logo-name">Willem Datema</span>
      </a>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        {navLinks.map(({ navLinkId, scrollToId, cta }, idx) => (
          <NavLink
            key={idx}
            navLinkId={navLinkId}
            scrollToId={scrollToId}
            setClick={handleClick}
            cta={cta}
          />
        ))}
      </ul>
      <div className="hamburger" onClick={handleClick}>
        {click ? <FaTimes size={26} /> : <FaBars size={26} />}
      </div>
    </div>
  );
};

export default Nav;
